import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import logoProductionPT from "../../imagens/logos/logoProductionCapabilities.png";
import logoProductionEN from "../../imagens/logos/logoProductionCapabilitiesEn.png";

import imgWireCapabilities from "../../imagens/wires/wireCapabilities.png";
import imgTestCapabilities from "../../imagens/testCapabilities.png";
import imgPlasticParts from "../../imagens/pecasplasticas/plasticCapabilities.png";
import imgWeldCapabilities from "../../imagens/welds/imgWeldCapabilties.png";
import imgMetrology from "../../imagens/metrology/imgMetrology.png";
import imgStamping from "../../imagens/stamping/imgStampingCapabilities.png";

import "./cardsProductionCapabilites.css";

function CardsProductionCapabilities() {
  const { t, i18n } = useTranslation();

  // Logo dinâmico conforme idioma
  const logoByLanguage = i18n.language === "en" ? logoProductionEN : logoProductionPT;

  const cardsData = [
    { img: imgWireCapabilities, alt: "Wire Capabilities", title: t("productionCapabilities.cards.wires"), link: "/Capabilities/Production/Wires" },
    { img: imgPlasticParts, alt: "Plastic Capabilities", title: t("productionCapabilities.cards.plastics"), link: "/Capabilities/Production/Plastics" },
    { img: imgStamping, alt: "Stamping Capabilities", title: t("productionCapabilities.cards.stamping"), link: "/Capabilities/Production/Stamping" },
    { img: imgWeldCapabilities, alt: "Welding Capabilities", title: t("productionCapabilities.cards.weldings"), link: "/Capabilities/Production/Weldings" },
    { img: imgTestCapabilities, alt: "Test Capabilities", title: t("productionCapabilities.cards.tests"), link: "/Capabilities/Production/WireChecks" },
    { img: imgMetrology, alt: "Metrology Capabilities", title: t("productionCapabilities.cards.metrology"), link: "/Capabilities/Production/MetrologyCapabilities" }
  ];

  return (
    <div>
      {/* LOGO */}
      <div className="text-start ms-2 mb-3">
        <img
          className="img-fluid img-custom-size"
          src={logoByLanguage}
          alt={t("productionCapabilities.logoAlt")}
        />
      </div>

      {/* CARDS */}
      <div className="pt-3">
        <div className="customrow w-100">
          {cardsData.map((card, index) => (
            <div key={index} className="hover-custom custom-width mb-4">
              <Link className="text-decoration-none" to={card.link}>
                <img src={card.img} className="img-fluid" alt={card.alt} />
                <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">
                  {card.title}
                </h2>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* BOTÃO VOLTAR */}
      <div className="text-center my-4">
        <Link to="/Capabilities">
          <button className="buttonCapabilities">
            {t("productionCapabilities.backButton")}
          </button>
        </Link>
      </div>
    </div>
  );
}

export default CardsProductionCapabilities;
